import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.stopPropagation()
    const isHidden = this.menuTarget.style.display === "none" || this.menuTarget.style.display === ""
    this.menuTarget.style.display = isHidden ? "block" : "none"
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.style.display = "none"
    }
  }

  connect() {
    this.menuTarget.style.display = "none"
    document.addEventListener("click", this.hide.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.hide.bind(this))
  }
}
